import { Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AudiSalesForceModuleSpecsFragment } from '../../../../api/fragments/AudiSalesForceModuleSpecs';

type AudiSalesForceModuleAuthorizationPageProps = {
    module: AudiSalesForceModuleSpecsFragment;
};

const AudiSalesForceModuleAuthorization = ({ module }: AudiSalesForceModuleAuthorizationPageProps) => {
    const { t } = useTranslation(['audiSalesForceModuleDetails']);

    const { authorization } = module;

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('audiSalesForceModuleDetails:tabs.authorization.descriptions.accessKey')}>
                    {authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('audiSalesForceModuleDetails:tabs.authorization.descriptions.secretKey')}>
                    {authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default AudiSalesForceModuleAuthorization;
